import cx from "classnames";
import Icon from "components/atoms/Icon";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledDonationPromo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: auto 100px;

  ${({ theme }) => theme.media["lg"]} {
    grid-column-gap: 4rem;
  }

  .donation-img-container {
    position: relative;
    margin-top: -0.5rem;
    width: 45px;

    img {
      max-width: none;
    }
  }
`;

/**
 * Displays our donation claim.
 *
 * @param {Object} props
 * @param {String} props.className
 */
const CheckoutDonationPromo = ({ className = "" }: { className?: string }) => {
  return (
    <StyledDonationPromo
      className={cx("donation-promo text-sm mt-8 mb-10", className)}
    >
      <div className="pr-8 lg:pr-0">
        With every plan purchased, we donate a book to a child.
      </div>
      <div className={"donation-img-container"}>
        <Icon name="holding-hands" size="44" />
      </div>
    </StyledDonationPromo>
  );
};

CheckoutDonationPromo.propTypes = {
  className: PropTypes.string,
};

export default CheckoutDonationPromo;
